import { SITE_BASE_URL, SITE_NAME } from '@/constants/site'

export interface BuildPageMetaInput {
  title: string
  description: string
  path: string
  image?: string
  type?: 'website' | 'product'
}

export interface PageMetaTag {
  title?: string
  name?: string
  property?: string
  content?: string
}

export interface PageLinkTag {
  rel: string
  href: string
}

export interface PageMetaResult {
  meta: PageMetaTag[]
  links: PageLinkTag[]
}

export function buildPageMeta({
  title,
  description,
  path,
  image,
  type = 'website',
}: BuildPageMetaInput): PageMetaResult {
  const url = `${SITE_BASE_URL}${path}`
  const absoluteImage = image ? `${SITE_BASE_URL}${image}` : undefined

  return {
    meta: [
      { title },
      { name: 'description', content: description },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:type', content: type },
      { property: 'og:url', content: url },
      { property: 'og:site_name', content: SITE_NAME },
      { property: 'og:locale', content: 'pt_BR' },
      ...(absoluteImage
        ? [{ property: 'og:image', content: absoluteImage }]
        : []),
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
    ],
    links: [{ rel: 'canonical', href: url }],
  }
}
